import React from "react";

import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";

import { orgByProjectIdSelector } from "Reducers/project/project";

export const withProjectRedirect = WrappedComponent => {
  const WithProjectRedirect = props => {
    const params = useParams();
    const orgByProjectId = useSelector(state =>
      orgByProjectIdSelector(state, {
        projectId: props.projectId || params.projectId
      })
    );
    const organizationId = props.organizationId || params.organizationId;
    const currentPath = window.location.pathname;
    const newPathSegments = currentPath.split("/").slice(2);

    const path = ["", orgByProjectId, ...newPathSegments].join("/");

    return organizationId !== orgByProjectId &&
      typeof orgByProjectId !== "undefined" ? (
      <Navigate to={path} replace />
    ) : (
      <WrappedComponent {...props} />
    );
  };

  WithProjectRedirect.displayName = `WithProjectRedirect(${getDisplayName(
    WrappedComponent
  )})`;

  WithProjectRedirect.propTypes = {
    organizationId: PropTypes.string,
    projectId: PropTypes.string
  };

  return WithProjectRedirect;
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}
